var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy_ynjc"},[_vm._v("Copyright © 2012-"+_vm._s(_vm.footerTime)+" 北京亿和博嘉教育科技有限公司  版权所有  京ICP备12019974号")])}
var staticRenderFns = []

export { render, staticRenderFns }